import React from 'react';
import Grid from '@mui/material/Grid2';

import { TransformStatsEnhancement } from "@dndModels";
import { ABILITY_SCORES } from '@dndModels/Constants';
import { AbilityScoreType } from '@dndModels/Types';

import PairedNumberEnhancementInput from './PairedNumberEnhancementInput';

interface Props {
  ability_scores: TransformStatsEnhancement;
  use_creature: boolean;
  disabled: boolean;
  onChange: () => void;
}

// Mirrors PairedStatsUGNInput's layout, one PairedNumberEnhancementInput per ability.
export default function TransformStatsEnhancementInput({
  ability_scores,
  use_creature,
  disabled,
  onChange
}: Props) {
  const quick_options = ABILITY_SCORES as AbilityScoreType[];

  return (
    <Grid container spacing={0} direction="row">
      <Grid size={12} className="header centered">Ability Scores</Grid>
      <Grid size={4}>
        <PairedNumberEnhancementInput name="Strength" value={ability_scores.strength} use_creature={use_creature} quick_options={quick_options} disabled={disabled} onChange={onChange} />
      </Grid>
      <Grid size={4}>
        <PairedNumberEnhancementInput name="Dexterity" value={ability_scores.dexterity} use_creature={use_creature} quick_options={quick_options} disabled={disabled} onChange={onChange} />
      </Grid>
      <Grid size={4}>
        <PairedNumberEnhancementInput name="Constitution" value={ability_scores.constitution} use_creature={use_creature} quick_options={quick_options} disabled={disabled} onChange={onChange} />
      </Grid>
      <Grid size={4}>
        <PairedNumberEnhancementInput name="Intelligence" value={ability_scores.intelligence} use_creature={use_creature} quick_options={quick_options} disabled={disabled} onChange={onChange} />
      </Grid>
      <Grid size={4}>
        <PairedNumberEnhancementInput name="Wisdom" value={ability_scores.wisdom} use_creature={use_creature} quick_options={quick_options} disabled={disabled} onChange={onChange} />
      </Grid>
      <Grid size={4}>
        <PairedNumberEnhancementInput name="Charisma" value={ability_scores.charisma} use_creature={use_creature} quick_options={quick_options} disabled={disabled} onChange={onChange} />
      </Grid>
    </Grid>
  );
}
